// Import translation
import { checkIsInt } from 'components/helpers/convert';
import i18n from 'i18next';

//import helpers from
import { validateInappropiateContent } from 'components/helpers/validation_helpers';

export default ({ metadata, number }) => {
	const errors = { metadata: {} };

	// ------------------ Number ------------------
	if (number === undefined || number === null) {
		errors.number = i18n.t('vod:seasons:validation.number_required');
	} else if (number < 0) {
		errors.number = i18n.t('vod:seasons:validation.negative_number');
	} else if (!checkIsInt(number)) {
		errors.number = i18n.t('vod:seasons:validation.integer_number');
	}

	// ------------------ Title ------------------
	if (!metadata.title) {
		errors.metadata.title = i18n.t('vod:form:validation.title');
	}

	// ------------------ Summary short ------------------
	if (!metadata.summary_short) {
		errors.metadata.summary_short = i18n.t('vod:form:validation.summary_short');
	}

	// ------------------ Rating ------------------
	// rating can be 0
	if (metadata.rating === undefined || metadata.rating === null) {
		errors.metadata.rating = i18n.t('vod:form:validation.rating');
	}
	// ------------------ category ------------------
	if (!metadata.category) {
		errors.metadata.category = i18n.t('vod:form:validation.category');
	}
	// ------------------ sub_category ------------------
	if (!metadata.sub_category?.length) {
		errors.metadata.sub_category = i18n.t('vod:form:validation.sub_category');
	}

	// ------------------ Inappropriate content ------------------
	const inappropriateContentError = validateInappropiateContent(
		metadata.additional_data.inappropriate_content
	);

	if (inappropriateContentError) {
		errors.metadata.additional_data = {
			...errors.metadata.additional_data,
			inappropriate_content: { lack: inappropriateContentError }
		};
	}

	return errors;
};
